import React, { useRef, useState } from "react";
import DialogModal from "../dialogModal";
import { t } from "../../i18n";
import StripePaymentDetailsForm from "@/components/subscriptions/stripePaymentDetailsForm";
import StripeElements from "@/components/subscriptions/stripeElements";
import { Button } from "@/components/ui/button";
import { useCreateStripeSetupIntent } from "@/hooks/subscriptions/useCreateStripeSetupIntent";
import { useCompanyIdFromUrl } from "@/hooks/companies/useCompanyIdFromUrl";
import LoadingPanel from "../loadingPanel";
import { useUpdateStripeCustomer } from "@/hooks/subscriptions/useUpdateStripeCustomer";
import { Plus } from "lucide-react";
export const AddPaymentMethodButton = ({ onClick, ...props }) => (
  <Button className="m-auto" variant="link" onClick={onClick} {...props}>
    <Plus size={14} /> {t("subscriptions.add_payment_card")}
  </Button>
);

const AddPaymentMethodModal = ({ onCancel }) => {
  const setupIntent = useCreateStripeSetupIntent();
  const companyId = useCompanyIdFromUrl();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const submitButtonRef = useRef();

  const {
    mutateAsync: updateStripeCustomer,
    isPending: isUpdatingCustomerPending,
  } = useUpdateStripeCustomer(companyId);

  const onAddPaymentMethod = async (stripeResponse) => {
    const paymentMethodId = stripeResponse?.setupIntent?.payment_method;

    paymentMethodId &&
      (await updateStripeCustomer({
        invoice_settings: {
          default_payment_method: paymentMethodId,
        },
        metadata: {
          isInvoiced: "false",
        },
      }));

    onCancel();
  };

  return (
    <DialogModal
      open
      title={t("subscriptions.add_payment_card")}
      submitText={t("subscriptions.add_payment_card")}
      bodyRenderer={() => (
        <div className="min-h-[300px] w-full">
          {setupIntent && companyId && !isUpdatingCustomerPending ? (
            <StripeElements setupIntent={setupIntent}>
              <StripePaymentDetailsForm
                companyId={companyId}
                submitButtonRef={submitButtonRef}
                onLoadingChanged={setIsSubmitting}
                onComplete={onAddPaymentMethod}
              />
            </StripeElements>
          ) : (
            <LoadingPanel />
          )}
        </div>
      )}
      onSubmit={() => {
        submitButtonRef.current?.click?.();
      }}
      isSubmitting={isSubmitting}
      onCancel={onCancel}
    />
  );
};

AddPaymentMethodModal.propTypes = {
  onCancel: DialogModal.propTypes.onCancel,
};

AddPaymentMethodModal.defaultProps = {
  onCancel: DialogModal.defaultProps.onCancel,
};

export default AddPaymentMethodModal;
